import React from "react";
import PropTypes from "prop-types";
import Masonry from "react-masonry-css";
import { Link } from "react-router-dom";
import {base_url} from '../common/Constants';

export default class   ProjectsContent  extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeFilter: "*" // "*" or ".cat-<id>"
    };
  }

  handleFilterClick = (e, filter) => {
    e.preventDefault();
    if (filter === this.state.activeFilter) return;
    this.setState({ activeFilter: filter });
  };

  // helper to decide whether a project should be shown
  isProjectVisible = (project) => {
    const { activeFilter } = this.state;
    if (!activeFilter || activeFilter === "*") return true;
    const cls = activeFilter.replace(/^\./, ""); // "cat-3"
    return String(project.type) === cls.replace(/^cat-/, String(project.type)) || projectHasClass(project, cls);
  };

  render() {
    const { project_types = [], projects = []  } = this.props;
    const { activeFilter } = this.state;

    // compute filtered list (preserve original order)
    const filtered = activeFilter === "*"
      ? projects
      : projects.filter(p => {
          const cls = activeFilter.replace(/^\./, "");
          return (`cat-${p.type}`) === cls;
        });

    // react-masonry-css breakpoints
    const breakpointCols = {
      default: 3, // desktop
      1100: 3,
      900: 2,
      600: 1
    };

    return (
      <div className="section-full p-t80 p-b50">
        <div className="container">
          <div className="filter-wrap p-tb15">
            <ul className="masonry-filter link-style text-uppercase">
              <li className={activeFilter === "*" ? "active" : ""}>
                <a href="#" data-filter="*" onClick={(e) => this.handleFilterClick(e, "*")}>All</a>
              </li>

              {project_types.map((item) => (
                <li key={item.id} className={activeFilter === `.cat-${item.id}` ? "active" : ""}>
                  <a
                    href="#"
                    data-filter={`.cat-${item.id}`}
                    onClick={(e) => this.handleFilterClick(e, `.cat-${item.id}`)}
                  >
                    {item.title}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <Masonry
            breakpointCols={breakpointCols}
            className="my-masonry-grid portfolio-wrap"
            columnClassName="my-masonry-grid_column"
          >
            {filtered.map((item) => (
              <div
                key={item.id}
                className={`masonry-item col-lg-4 col-md-4 col-sm-6 col-xs-6 cat-${item.type}`}
              >
                <div className="wt-gallery-bx p-a15">
                  <div className="wt-thum-bx wt-img-overlay5 wt-img-effect blurr">
                     <Link to={base_url+"project-info/"+item.slug}>
                      <img src={item.image} alt={item.title} />
                    </Link>

                    <div className="overlay-bx">
                      <div className="overlay-icon">
                         <Link to={base_url+"project-info/"+item.slug}>
                          <i className="fa fa-external-link wt-icon-box-xs"></i>
                        </Link> 
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            ))}
          </Masonry>
        </div>
      </div>
    );
  }
}

ProjectsContent.propTypes = {
  project_types: PropTypes.array, // [{id, title}, ...]
  projects: PropTypes.array,      // [{id, type, title, slug, image}, ...]
  base_url: PropTypes.string
};

// small helper used above if you want more flexible matching (not required)
function projectHasClass(project, cls) {
  // example: if project has a classes array or type is not numeric you can customize here
  // return project.classes && project.classes.includes(cls);
  return (`cat-${project.type}`) === cls;
}
